/* libs */
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import moment from "moment";

/* components */
import Page from "../../shared/Page";
import GridFormSwitcher from "../../shared/GridFormSwitcher";
import TableUI from "./TableUI";
import SessionsFormWrapper from "./SessionsFormWrapper";

/* helpers */
import * as globalActions from "../../../actions/globalActions";
import * as pagesActions from "../../../actions/pagesActions";
import * as sessionsActions from "../../../actions/sessionsActions";
import * as topicsActions from "../../../actions/topicsActions";
import * as controlPanelActions from "../../../actions/controlPanelActions";
import ErrorHandler from "../../../helpers/validation/errorHandler";

class SessionsPage extends Component {
	constructor(props) {
		super(props);
		this.appKey = this.props.match.params.appKey;
		this.state = {
			formApi: undefined,
		};
	}

	componentDidMount() {
		this.loadSessions(this.appKey);
		this.props.topicsActions.loadTopics(this.appKey);
	}

	getApi = formApi => {
		this.setState({ formApi });
	};

	getAppId = key => {
		const { apps } = this.props;
		const app = apps.find(a => a.key === key);
		return app.id;
	};

	reloadSessions = () => {
		const { sessionsActions, history } = this.props;
		sessionsActions.loadSessions(this.appKey);
		history.push(`/apps/${this.appKey}/sessions`);
	};

	loadSessions = appId => {
		this.props.sessionsActions.loadSessions(appId);
	};

	logError = error => {
		ErrorHandler(error, this.state.formApi, this.props.controlPanelActions);
		//alert("Boo...");
		console.log(">>>: ", JSON.stringify(error));
		//this.props.validationActions.updateFormErrors(error.response.data.Errors);
	};

	createItem = (values, submitHandler) => {
		const { globalActions } = this.props;
		const id = this.getAppId(this.appKey);
		const data = {
			...values,
			appId: id,
		};
		globalActions.createItem(data, "/sessions", this.reloadSessions, this.logError, submitHandler);
	};

	updateItem = (values, submitHandler, itemId) => {
		//TODO: item to update has be different than what will be sent out
		const { globalActions } = this.props;
		globalActions.updateItem(values, `/sessions/${itemId}`, this.reloadSessions, this.logError, submitHandler);
	};

	copyItem = (values, submitHandler) => {
		const publishAt = moment.utc().format();
		const { globalActions } = this.props;
		const id = this.getAppId(this.appKey);
		const data = {
			...values,
			appId: id,
			publishAt: publishAt,
		};
		globalActions.createItem(data, "/sessions", this.reloadSessions, this.logError, submitHandler);
	};

	deleteItem = (id, name) => {
		let appKey = this.appKey;
		const { sessionsActions, globalActions } = this.props;
		const onSuccess = () => {
			sessionsActions.loadSessions(appKey);
		};
		globalActions.deleteItem(`/sessions/${id}`, onSuccess, this.logError, name);
	};

	renderGrid = () => {
		const { sessions } = this.props.sessions;
		return (
			<div>
				{sessions ? (
					<div className="table-ui">
						<TableUI items={sessions} delete={this.deleteItem} appKey={this.appKey} />
					</div>
				) : (
					<div></div>
				)}
			</div>
		);
	};

	render() {
		const { sessions } = this.props.sessions;

		return (
			<Page title="Sessions">
				{sessions ? (
					<GridFormSwitcher
						objectKey="Sessions"
						singleItemName="Session"
						pluralItemName="Sessions"
						RenderCopy={SessionsFormWrapper}
						RenderEdit={SessionsFormWrapper}
						RenderNew={SessionsFormWrapper}
						items={sessions}
						renderGrid={this.renderGrid}
						createItem={this.createItem}
						updateItem={this.updateItem}
						copyItem={this.copyItem}
						loadPages={this.loadPages}
						topics={this.props.topics}
						getApi={this.getApi}
					/>
				) : (
					<h1>Loading...</h1>
				)}
			</Page>
		);
	}
}

SessionsPage.propTypes = {
	match: PropTypes.any,
	sessions: PropTypes.object,
	actions: PropTypes.any,
	globalActions: PropTypes.any,
	history: PropTypes.object,
	apps: PropTypes.array,
	pagesActions: PropTypes.object,
	sessionsActions: PropTypes.object,
	topicsActions: PropTypes.object,
	topics: PropTypes.array,
	controlPanelActions: PropTypes.object,
};

const mapStateToProps = state => ({
	apps: state.apps.apps,
	sessions: state.sessions,
	topics: state.topics.topics,
});

const mapDispatchToProps = dispatch => ({
	sessionsActions: bindActionCreators(sessionsActions, dispatch),
	globalActions: bindActionCreators(globalActions, dispatch),
	pagesActions: bindActionCreators(pagesActions, dispatch),
	topicsActions: bindActionCreators(topicsActions, dispatch),
	controlPanelActions: bindActionCreators(controlPanelActions, dispatch),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(SessionsPage);
